import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { IClassificationState } from 'sustainment-component';
import { ClassificationStore } from './classification.store';

@Injectable({ providedIn: 'root' })
export class ClassificationQuery extends Query<IClassificationState> {
  public constructor(protected store: ClassificationStore) {
    super(store);
  }
}
